import { Component, HostListener, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {


  constructor() {

  }

  ngOnInit(): void {
    this.footerDate = new Date().getFullYear() > 2008 && "-" + new Date().getFullYear();
  }
  
  location: any = ""
  links = [
    {
      "id": 1,
      "title": "Cloud Insights Dashboard",
      "items": [
        {
          "link": "/cloud-insights/cloud-activity-dashboard",
          "title": "Cloud Activity",
        },
        // {
        //   "link": "/cloud-insights/cloud-application-dashboard",
        //   "title": "Cloud Application",
        // },
        {
          "link": "/cloud-insights/threat-map-dashboard",
          "title": "Global Threat Map Dashboard",
        },
        {
          "link": "/cloud-insights/global-enforcement-dashboard",
          "title": "Global Enforcement",
        },
        {
          "link": "/cloud-insights/global-isp-incidents",
          "title": "Global ISP",
        },
        {
          "link": "/cloud-insights/global-internet-threats-insights",
          "title": "Global Internet Threat Insights",
        },
        {
          "link": "/cloud-insights/encrypted-traffic-dashboard",
          "title": "Encrypted Traffic",
        },
        {
          "link": "/cloud-insights/iot-dashboard",
          "title": "Internet of Things",
        },
        {
          "link": "/cloud-insights/work-from-anywhere-dashboard",
          "title": "Work From Anywhere Trends",
        }

      ]
    }
  ]

  links2 = [{
    "id": 2,
    "title": "Resources",
    "items": [
      {
        "title": "Threat Library",
        "link": "/threat-library",
        "extraLink": false
      },
      {
        "title": "URL Check",
        "link": "/tool/url-check",
        "extraLink": false
      },
      {
        "title": "URL Analysis",
        "link": "/tool/url-analysis",
        "extraLink": false
      },
      // {
      //   "title": "File Check",
      //   "link": "/files/file-check",
      //   "extraLink": false
      // },
      // {
      //   "title": "URL Analysis",
      //   "link": "https://zulu.zscaler.com/",
      //   "extraLink": true
      // },
      // {

      //   "link": "http://filecheck.zscaler.com",
      //   "title": "File Check",
      //   "extraLink": true
      // },
      {
        "title": "Security Advisories",
        "link": "/security-advisories",
        "extraLink": false
      },
      {
        "title": "Research Blogs",
        "link": "/blogs",
        "extraLink": false
      },


    ]
  }]

  footerDate: any;

}
